import React from 'react';
import ReactDOM from 'react-dom/client';
import './startups/index.css';
import App from './startups/App';
import reportWebVitals from './startups/reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
